<template>
  <div class="yx-predicted-approval-page main-layout">
    <el-card class="box-form box-outter">
      <el-tabs v-model="currentTab" @tab-click="handleClick">
        <el-tab-pane label="待审核" name="first">
          <audit />
        </el-tab-pane>
        <el-tab-pane label="已审核" name="second">
          <reviewed />
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import Audit from "./components/majorAudit";
import Reviewed from "./components/majorReviewed";
export default {
  name: "",
  components: {
    Audit,
    Reviewed,
  },
  data() {
    return {
      currentTab: "first",
    };
  },
  created() {},
  mounted() {},
  methods: {
    handleClick() {},
  },
};
</script>
